var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3335 58.6667V47.6L20.6668 56.1334L16.9335 52.4L29.3335 40V34.6667H24.0002L11.6002 47.0667L7.86683 43.3334L16.4002 34.6667H5.3335V29.3334H16.4002L7.86683 20.6667L11.6002 16.9334L24.0002 29.3334H29.3335V24L16.9335 11.6L20.6668 7.86671L29.3335 16.4V5.33337H34.6668V16.4L43.3335 7.86671L47.0668 11.6L34.6668 24V29.3334H40.0002L52.4002 16.9334L56.1335 20.6667L47.6002 29.3334H58.6668V34.6667H47.6002L56.1335 43.3334L52.4002 47.0667L40.0002 34.6667H34.6668V40L47.0668 52.4L43.3335 56.1334L34.6668 47.6V58.6667H29.3335Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoad);
export default __webpack_public_path__ + "static/media/IconLoad.f59cd871776e9b1f66d4c74ac89ae24a.svg";
export { ForwardRef as ReactComponent };